import request from '../../../api/request';
import {
  CreateSurveyEvaluationScalesRequest,
  EvaluationScalesResponse,
} from './types';

const SURVEY_EVALUATION_SCALES = {
  LIST: () => `maintainers-portal/management-tools/surveys-scales`,
  CREATE: () => `maintainers-portal/management-tools/surveys-scales`,
  GET: (id: string) =>
    `maintainers-portal/management-tools/surveys-scales/${id}`,
  UPDATE: (id: string) =>
    `maintainers-portal/management-tools/surveys-scales/${id}`,
  DELETE: (id: string) =>
    `maintainers-portal/management-tools/surveys-scales/${id}`,
};

export async function getEvaluationScales() {
  return request<EvaluationScalesResponse[]>(SURVEY_EVALUATION_SCALES.LIST(), {
    method: 'GET',
  });
}

export async function getEvaluationScale(id: string) {
  return request<EvaluationScalesResponse>(SURVEY_EVALUATION_SCALES.GET(id), {
    method: 'GET',
  });
}

export async function createEvaluationScale(
  data: CreateSurveyEvaluationScalesRequest,
) {
  return request(SURVEY_EVALUATION_SCALES.CREATE(), {
    method: 'POST',
    data,
  });
}

export async function updateEvaluationScale(
  id: string,
  data: CreateSurveyEvaluationScalesRequest,
) {
  return request(SURVEY_EVALUATION_SCALES.UPDATE(id), {
    method: 'PUT',
    data,
  });
}

export async function deleteEvaluationScale(id: string) {
  return request(SURVEY_EVALUATION_SCALES.DELETE(id), {
    method: 'DELETE',
  });
}
